import { render, staticRenderFns } from "./CustomerMaterialMappingList.vue?vue&type=template&id=27b6f770&"
import script from "./CustomerMaterialMappingList.vue?vue&type=script&lang=js&"
export * from "./CustomerMaterialMappingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports